// const apiEndpoint = process.env.VUE_APP_API_ENDPOINT;
// const apiHost = process.env.VUE_APP_API_HOST;
// const apiPort = process.env.VUE_APP_API_PORT;
import { appStore } from '@/stores/AppStore'

class ApiService {
    constructor() {
        this.baseURL = process.env.VUE_APP_API_ENDPOINT //|| 'http://localhost:7070/api'
    }

    //We avoid having a setter as setting of token should not be in this transportation
    //layer class. We have the getter only as to make things easier
    get token() {
        return appStore().token;
    }

    // Generic request method
    async request(endpoint, options = {}) {
        const url = `${this.baseURL}${endpoint}`
        console.log(`ApiService > request > url = ${url}`)
        console.log(`ApiService > request > Token = ${this.token}`)

        const config = {
            headers: {
                'Content-Type': 'application/json',
                ...(this.token && { 'Authorization': `Bearer ${this.token}` }),
                ...options.headers
            },
            ...options
        }

        console.log(`ApiService > request > url = ${url}, config = `, config);

        try {
            const response = await fetch(url, config)
            const body = await response.json()/*.catch(() => ({}))*/;

            if (!response.ok) {
                if (response.status === 401) {
                    // Handle unauthorized - redirect to login
                    this.handleUnauthorized()
                    throw new Error('Unauthorized')
                }
                throw new Error(body.message || `HTTP ${response.status}: ${response.statusText}`)
            }

            return body
        } catch (error) {
            console.error('API Request failed:', error)
            throw error
        }
    }

    // Authentication methods
    // setToken(token) {
    //     this.token = token
    //     localStorage.setItem('authToken', token)
    // }

    clearToken() {
        // this.token = null
        localStorage.removeItem('authToken')
        localStorage.removeItem('user') //TODO: This should be moved out of this class
        // appStore.setToken(null);
    }

    handleUnauthorized() {
        this.clearToken()
        // Redirect to login or emit event
        window.location.href = '/login'
    }


    //-----------------------------Clients--------------------------------------
    async getClientsForPsychologist() {
        let r =  await this.request(`/psychologist/clients`, {
            method: 'GET'
        });

        return r.data;
    }

    async createClient(userData) {
        return await this.request('/psychologist/clients', {
            method: 'POST',
            body: JSON.stringify(userData)
        })
    }

    async getClientsNo(){
        let r =  await this.request(`/users/count`, {
            method: 'GET'
        });
        return r;
    }


    //---------------------------Evaluations------------------------------------
    async createEvaluation(evaluationData) {
        return await this.request('/evaluations', {
            method: 'POST',
            body: JSON.stringify(evaluationData)
        })
    }

    async getEvaluations() {
        return await this.request('/evaluations', {
            method: 'GET'
        })
    }

    async getEvaluationsTotalNo() {
        return await this.request('/evaluations/count', {
            method: 'GET'
        })
    }

    async getEvaluationById(evaluationId) {
        console.log(`ApiService > getEvaluationById > evaluationId = ${evaluationId}`)
        return await this.request(`/evaluations/${evaluationId}`, {
            method: 'GET'
        })
    }
    async getEvaluationByToken(evaluationToken) {
        console.log(`ApiService > getEvaluationByToken > evaluationToken = ${evaluationToken}`)
        return await this.request(`/evaluations/by-token/${evaluationToken}`, {
            method: 'GET'
        })
    }
    async getPublicEvaluationByToken(evaluationToken) {
        console.log(`ApiService > getPublicEvaluationByToken > evaluationToken = ${evaluationToken}`)
        return await this.request(`/evaluations/token/${evaluationToken}`, {
            method: 'GET'
        })
    }
    
    async getEvaluationClientFingerByToken(evaluationToken) {
        console.log(`ApiService > getEvaluationClientFingerByToken > evaluationToken = ${evaluationToken}`)
        return await this.request(`/evaluations/token/${evaluationToken}/finger`, {
            method: 'PATCH'
        })
    }

    async submitResponses(evaluationToken, fingerprint, answers, evaluation_link_fragment) {
        return await this.request(`/evaluations/token/${evaluationToken}/answers`, {
            method: 'POST',
            body: JSON.stringify({
                answers: answers,
                fingerprint: fingerprint,
                evaluation_link_fragment: evaluation_link_fragment
            })
        })
    }

    //TODO: rename it to getEvaluationByToken
    async getEvaluation(token) {
        // If token is needed, pass as query param
        const query = token ? `?token=${encodeURIComponent(token)}` : '';
        return await this.request(`/evaluations${query}`);
    }

    
    /**Gets all evaluations for a client (of currently logged psychologist) */
    async getEvaluationsForClient(clientId) {
        return await this.request(`/evaluations?clientId=${clientId}`, {
            method: 'GET'
        })
    }

    async deleteEvaluation(evaluationId) {
        return await this.request(`/evaluations/${evaluationId}`, {
            method: 'DELETE'
        })
    }


    //---------------------------Items------------------------------------
    async getItems(evaluationToken) {
        console.log(`ApiService > getQuestions > evaluationToken = ${evaluationToken}`)
        return await this.request(`/evaluations/token/${evaluationToken}/items`, {
            method: 'GET'
        })
    }


    //---------------------------Scales------------------------------------
    // Scales Management
    async getScales(language='en') {
        return await  this.request(`/scales?lang=${language}`)
    }


    //---------------------------Users------------------------------------
    // User Management
    async getUsers() {
        return await this.request('/users')
    }

    async getUser(id) {
        console.log(`ApiService > getUser > id = ${id}`)
        return await this.request(`/users/${id}`)
    }


    async createUser(userData) {
        return await this.request('/users', {
            method: 'POST',
            body: JSON.stringify(userData)
        })
    }

    async updateUser(id, userData) {
        return await  this.request(`/users/${id}`, {
            method: 'PATCH',
            body: JSON.stringify(userData)
        })
    }

    async deleteUser(id) {
        return await  this.request(`/users/${id}`, {
            method: 'DELETE'
        })
    }

    async updateProfile(userData){
        return await  this.request(`/auth/profile`, {
            method: 'PUT',
            body: JSON.stringify(userData)
        })
    }

    // async refreshToken(){
    //     return await  this.request(`/auth/profile`, {
    //         method: 'PUT',
    //         body: JSON.stringify({})
    //     })
    // }    
}


// Create and export a singleton instance
const apiService = new ApiService()
export default apiService